interface pointsCountProps {
    points: string;
    scoreType?: "points" | "stars" | string;
}

export const PointsCount: React.FC<pointsCountProps> = ({
    points,
    scoreType = "points",
}) => {
    return (
        <div className="flex flex-row items-center justify-center">
            <div className="w-6 h-6 rounded-full ">
                <img
                    src={
                        scoreType === "stars"
                            ? "/assets/images/star-full.png"
                            : "/assets/images/points-coin.png"
                    }
                    alt={scoreType === "stars" ? "star" : "coin"}
                    className="object-contain w-full h-full"
                />
            </div>
            <span className="ml-2 text-base font-bold text-dark-purple">
                {points}
            </span>
        </div>
    );
};
